import { EGuestHomepageVersions } from 'Components/pages/GuestHomepage/types';
import SupportedPayments from '../SupportedPayments/SupportedPayments';

interface ISupportedPaymentsManager {
  version?: EGuestHomepageVersions;
  payment_methods: any;
}
const SupportedPaymentsManager = ({
  version = EGuestHomepageVersions.B,
  payment_methods,
}: ISupportedPaymentsManager) => {
  return (
    <>
      {(version == EGuestHomepageVersions.B || version == EGuestHomepageVersions.B2) && (
        <>
          <SupportedPayments
            payment_methods={payment_methods}
            buttonColor={'rgba(127, 48, 227, 0.75)'}
          ></SupportedPayments>
        </>
      )}

      {(version == EGuestHomepageVersions.C || version == EGuestHomepageVersions.C2) && (
        <>
          <SupportedPayments
            payment_methods={payment_methods}
            buttonColor={'var(--w-white-30, rgba(255, 255, 255, 0.30))'}
          ></SupportedPayments>
        </>
      )}
    </>
  );
};
export default SupportedPaymentsManager;
